import { Component, OnInit, Input, Inject } from '@angular/core';
import {
  UntypedFormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
  AsyncValidatorFn,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { PerfilesPop } from '@pages/fabrica-credito/interfaces/perfil';
import { PerfilService } from '@pages/perfil/services/perfil.service';
import { InjectableService } from '@shared/utils/injectable.service';
import { SwalService } from '@shared/utils/swal.service';
import { PerfilComponent } from '../perfil.component';
import { VariablesComponent } from '@pages/variables/variables.component';
import { RangosComponent } from '@pages/rangos/rangos.component';
import { AuditarComponent } from '@pages/auditar/auditar.component';

@Component({
  selector: 'app-perfil-form',
  templateUrl: './perfil-form.component.html',
  styleUrls: ['./perfil-form.component.css'],
})
export class PerfilFormComponent implements OnInit {
  @Input() modelRecived: PerfilesPop;
  public loading: boolean;
  public breakpoint: number;
  private readonly _width: string = '900px';
  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<PerfilComponent>,
    private _swalService: SwalService,
    private _injectServices: InjectableService,
    private _perfilService: PerfilService,
    public _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public model: PerfilesPop
  ) {}

  ngOnInit(): void {
    this.setForm();
  }

  form = this._fb.group({
    clavePerfil: ['', Validators.required],
    descripcion: ['', Validators.required],
    scoreInicial: ['', Validators.required],
  });

  formValue(value: string) {
    return this.form.get(value);
  }

  setForm(): void {
    this.modelRecived = this.model;
    if (this.modelRecived) {
      let model: PerfilesPop = this.modelRecived;
      const setModel = {
        clavePerfil: model.clavePerfil,
        descripcion: model.descripcion,
        scoreInicial: model.scoreInicial,
      };
      this.form.patchValue(setModel);
    }
  }

  create(model: PerfilesPop) {
    if (this.form.valid) {
      model.user = JSON.parse(sessionStorage.getItem('Usser'));
      this.loading = true;
      this._perfilService.create(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Agregado');
        } else
          this._swalService.error(
            'No Agregado, Puede ser que la clave ya exista, valide con una diferente por favor!'
          );
      });
    }
  }

  openVariables() {
    const dialogRef = this._dialog.open(VariablesComponent, {
      width: this._width,
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }

  openRangos() {
    const dialogRef = this._dialog.open(RangosComponent, {
      width: this._width,
    });
    dialogRef.afterClosed().subscribe((res) => {});
  } 
  
  openAuditar() {
    let model: PerfilesPop = this.modelRecived; 
    const dialogRef = this._dialog.open(AuditarComponent, {
      width: this._width,
      data: {
        clavePerfilOp: model.clavePerfil
      }
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }

  update(model: PerfilesPop) {
    if (this.form.valid) {
      this.loading = true;
      this._perfilService.update(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Editado');
        } else this._swalService.error('No Editado');
      });
    }
  }

  variableValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const variable = control.value;

      if (!variable) return;

      if (variable < 501 || variable > 600) return { variableValidation: true };

      return null;
    };
  }

  singleDefinicion(): AsyncValidatorFn {
    return (
      control: AbstractControl
    ): Promise<ValidationErrors> | Observable<any> => {
      if (this.modelRecived) return of(true);
      else {
        return this._perfilService.read().pipe(
          map((res) => {
            if (res.exito === 1) return { singleDefinicion: true };
            return null;
          })
        );
      }
    };
  }

  onBreakPonit() {
    this.breakpoint = window.innerWidth <= 200 ? 1 : 2;
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 200 ? 1 : 2;
  }

  close() {
    this._dialogRef.close();
  }
}
